import { render } from "./DeleteKnowledgeBaseFileDialog.vue?vue&type=template&id=63306062&scoped=true"
import script from "./DeleteKnowledgeBaseFileDialog.vue?vue&type=script&lang=js"
export * from "./DeleteKnowledgeBaseFileDialog.vue?vue&type=script&lang=js"

import "./DeleteKnowledgeBaseFileDialog.vue?vue&type=style&index=0&id=63306062&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63306062"]])

export default __exports__